jQuery(function($){
    var clndrTemplate =
        "<div class='clndr-controls'>" +
            "<div class='clndr-control-button'>" +
                "<button type='button' class='clndr-previous-button'><span class='screen-reader-text'>Previous Month</span><span class='fa fa-angle-left' aria-hidden='true'></span></button>" +
            "</div>" +
            "<div class='clndr-control-button rightalign'>" +
                "<button type='button' class='clndr-next-button'><span class='screen-reader-text'>Next Month</span><span class='fa fa-angle-right' aria-hidden='true'></span></button>" +
            "</div>" +
        "</div>" +
        "<% for(var mm = 0; mm < months.length; mm++){ %>" +
            "<div class='month-wrapper month-<%=mm %>'>" +
                "<div class='month'><strong><%= months[mm].month.format('MMMM') %></strong> <%= months[mm].month.year() %></div>" +
                "<table class='clndr-table' border='0' cellspacing='0' cellpadding='0'>" +
                    "<thead>" +
                        "<tr class='header-days'>" +
                        "<% for(var i = 0; i < daysOfTheWeek.length; i++) { %>" +
                            "<th scope='col' class='header-day'><abbr title='<%= extras.weekdays[i] %>'><%= extras.weekdaysshort[i] %></abbr></th>" +
                        "<% } %>" +
                        "</tr>" +
                    "</thead>" +
                    "<tbody>" +
                    "<% for(var i = 0; i < Math.ceil(months[mm].days.length / 7); i++){ %>" +
                        "<tr>" +
                        "<% for(var j = 0; j < 7; j++){ %>" +
                        "<% var d = j + i * 7; %>" +
                            "<td class='<%= months[mm].days[d].classes %>'>" +
                                "<<%=months[mm].days[d].events.length>0?'a href=\"javascript:void(0);\"':'span' %> class='day-contents'><span class='screen-reader-text'><%= months[mm].month.format('MMMM') %> </span><%= months[mm].days[d].day %></<%=months[mm].days[d].events.length>0?'a':'span' %>>" +
                            "</td>" +
                        "<% } %>" +
                        "</tr>" +
                    "<% } %>" +
                    "</tbody>" +
                "</table>" +
            "</div>" +
        "<% } %>" +
        "<div class='loading'></div>"
        ;

    $('.appointment-calendar-v3').each(function(){
        var appointment_calendar = $(this);
        var upcomingEvents = null;
        var recaptcha_id = false;
        var selectedTimeSlot = null;
        var selectedCard = null;
        var config = appointment_calendar.data('config');
        if(config)
            config = atob(config);
        if(config)
            config = JSON.parse(config);
        if(!config)
            return;

        window.onpageshow = function(event) {
            if (event.persisted && recaptcha_id!==false) {
                grecaptcha.reset(recaptcha_id);
            }
        };

        $('.clndr-holder', appointment_calendar).removeClass('not-loaded');
        var qparams = $.getQueryParameters();
        var refparams = {};
        if(document.referrer.split("?").length == 2)
            refparams = $.getQueryParameters(document.referrer.split("?")[1]);
        

        if(typeof wp_vars['apt_datetime'] != 'undefined')
            qparams['apt']=wp_vars['apt_datetime'];
        if(typeof refparams['apt_date'] != 'undefined')
            qparams['apt']=refparams['apt_date'];
        if(typeof qparams['apt_date'] != 'undefined')
            qparams['apt']=qparams['apt_date'];

        var test_mode = appointment_calendar.data('test-mode');
        var en_appt_override = appointment_calendar.data('en-appt-override');
        var upcoming_events = appointment_calendar.data('upcoming-events');
        var appointment_types = Object.keys(config);

        var calendar_start=appointment_calendar.data('calendar-start');
        if(calendar_start)
            calendar_start = moment(calendar_start+'');
        else
            calendar_start = moment();
        if(calendar_start.isBefore(moment()))
            calendar_start = moment();

        var apt_page_url=false;
        if(typeof wp_vars["apt_page_url"] != 'undefined')
            apt_page_url = wp_vars["apt_page_url"];

        $('.events-area .info-button', appointment_calendar).click(infoButtonClick);

        var cal = $('.clndr-holder', appointment_calendar).clndr({
            template:clndrTemplate,
            lengthOfTime: {
                months: 2,
                interval: 2,
                startDate: calendar_start,
            },
            extras:{
                weekdays:['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                weekdaysshort:['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            },
            clickEvents: {
                click: onDayClick,
                onIntervalChange: onIntervalChange,
            },
            constraints: {
                startDate: calendar_start,
                endDate: moment().add(12, 'M')
            },
            showAdjacentMonths: false
        });
        
        $('button.reserve-date', appointment_calendar).click(function(){
            appointment_calendar.find('.bottom-errors').html('Please select a date to continue');
        });  

        function onDayClick(target)
        {
            if(target.events.length==0)
                return;

            if(appointment_calendar.find('.top-area .mobile-top').css('display') == "block") {
                $('html, body').animate({
                    scrollTop: appointment_calendar.find('.right').offset().top - 30
                }, 500);
            }

            $('.clndr .day',appointment_calendar).removeClass('active');
            $(target.element).addClass('active');

            appointment_calendar.addClass('date-selected');
         
            if(recaptcha_id===false)
            {
                grecaptcha.ready(function() {
                    recaptcha_id=grecaptcha.render('g-recaptcha-appointment-cal', {
                      'sitekey': '6Lex9ScUAAAAAJMZmJ_BnKc6c1_6XA4owii48Bnz',
                      'size': 'invisible',
                      'callback': function(token){//on execute
                        appointment_calendar.find('.errors').html("");
                        if(!selectedTimeSlot)
                            return;
                        if(!selectedCard)
                            return;
                        
                        var args={
                            'appointmentType':selectedTimeSlot.type,
                            'appointmentDate':selectedTimeSlot.date,
                            'token':token,
                            'appt-cal':true,
                            'duration':selectedTimeSlot.duration,
                            'guests':selectedTimeSlot.guests,
                        };
                        if(en_appt_override)
                            args['en_appt_override']=1;
                        if(test_mode)
                            args['test_mode']=1;
                        
                        $.post('/',args,function(resp){
                            appointment_calendar.find('.card button').attr('disabled',false);
                            if(typeof resp.ok == 'undefined')
                            {
                                selectedCard.find('.errors').html('Server error (0)');
                                grecaptcha.reset(recaptcha_id);
                                return;
                            }
                            if(!resp.ok)
                            {
                                selectedCard.find('.errors').html(resp.error);
                                grecaptcha.reset(recaptcha_id);
                                return;
                            }
                            if(apt_page_url.indexOf('?')===-1)
                                window.location.href=apt_page_url+'?booking=1';
                            else
                                window.location.href=apt_page_url+'&booking=1';
                        });
                      }
                    });
                });
            }

            //BEGIN events
            appointment_calendar.find('.events-area .events').empty();
            appointment_calendar.find('.events-area').hide();
            for(var ii in upcomingEvents) {
                if(upcomingEvents[ii].start.isSameOrBefore(target.date) && upcomingEvents[ii].end.isSameOrAfter(target.date)) {
                    var designerEvent = $('<div class="event">');
                    designerEvent.html(upcomingEvents[ii].designer);
                    appointment_calendar.find('.events-area .events').append(designerEvent);
                    appointment_calendar.find('.events-area').show();
                    break;//one event only
                }
            }
            //END events

            var eventsByType = [];
            var topTimes90 = new Map();
            var topTimesVIP = new Map();
            var cards = [];

            for(var ii in target.events)
            {       
                if(typeof config[target.events[ii].type] == 'undefined')
                    continue;
                if(target.events[ii].slots < 1)
                    continue;//remove if no slots
                
                var time = moment(target.events[ii].date).format('h:mma'); 
                var topBtn = makeTimeButton(target.events[ii], false);
                topBtn.data('counterparts', []);
                if(config[target.events[ii].type].vip)
                    topTimesVIP.set(time, topBtn);
                else
                    topTimes90.set(time, topBtn);
                
                if(!eventsByType[target.events[ii].type])
                    eventsByType[target.events[ii].type] = {price: getFeeForEvent(target.events[ii]), slots: 0, events: []};
                eventsByType[target.events[ii].type].events.push(target.events[ii]);
                eventsByType[target.events[ii].type].slots += target.events[ii].slots;
            }

            for(var type in config) {
                if(typeof eventsByType[type] == 'undefined' && config[type].show_unavailable) {
                    var emptyEvent = {
                        type: type,
                        guests: config[type].unavail_guests,
                        duration: config[type].unavail_duration,
                        date: target.date,
                    };
                    eventsByType[type] = {
                        price: getFeeForEvent(emptyEvent),
                        slots: 0,
                        events: [emptyEvent]
                    };
                }
            }

            eventsByType = Object.values(eventsByType);
            eventsByType.sort(function(a, b){
                if(a.slots && b.slots)//both have slots
                    return a.price > b.price ? 1 : -1;
                else if(!a.slots && !b.slots)//neither have slots
                    return a.price > b.price ? 1 : -1;
                else//one has slots and the other doesn't
                    return b.slots ? 1 : -1;
            });

            for(var ii in eventsByType)
            {
                var cardTimes = [];
                var card = makeCard(eventsByType[ii].events[0]);
                for(var jj in eventsByType[ii].events)
                {
                    if(!eventsByType[ii].events[jj].slots)
                        continue;
                    
                    var cardBtn = makeTimeButton(eventsByType[ii].events[jj], true);
                    cardTimes.push(cardBtn);

                    var time = moment(eventsByType[ii].events[jj].date).format('h:mma');
                    var topBtn = null;
                    if(config[eventsByType[ii].events[jj].type].vip)
                        topBtn = topTimesVIP.get(time);
                    else
                        topBtn = topTimes90.get(time);
                    var btnCards = topBtn.data('counterparts');
                    btnCards.push(cardBtn);
                    topBtn.data('counterparts', btnCards);
                }
                card.data('setTimes')(cardTimes);
                cards.push(card);
            }

            var topTimesElem = appointment_calendar.find('.top-times').empty();
            if(topTimes90.size > 0) {
                topTimesElem.append('<h3>90-minute appointment times</h3>');
                topTimesElem.append(Array.from(topTimes90.values()));
            }
            if(topTimesVIP.size > 0) {
                topTimesElem.append('<h3>3-hour VIP appointment times</h3>');
                topTimesElem.append(Array.from(topTimesVIP.values()));
            }
            
            appointment_calendar.find('.cards').empty().append(cards);
            appointment_calendar.find('.top-area').show();
            qparams['apt'] = false;
        }
        function onIntervalChange(month)
        {
            var nextMonth = moment(month).add(1, 'M');
            getCalendarEvents(month.format('YYYY-MM'), moment().diff(month, 'month') < -1);

            appointment_calendar.removeClass('date-selected');
            appointment_calendar.find('.events-area .events').empty();
            appointment_calendar.find('.events-area').hide();
            appointment_calendar.find('.top-times').empty();
            appointment_calendar.find('.cards').empty();
            appointment_calendar.find('.top-area').hide();
            appointment_calendar.find('.bottom-errors').html('');
            selectedTimeSlot = null;
            selectedCard = null;
        }     

        function getCalendarEvents(month, isFuture)
        {
            $('.clndr-holder .loading', appointment_calendar).show();
            cal.setEvents([]);
            appointment_calendar.find('.unopen-month').hide();
            appointment_calendar.find('button.reserve-date').show();
            var args = {getCalendar:month, showAdjacentMonths: false, numberOfMonths: 2};
            if(appointment_types)
                args['appointmentType'] = appointment_types;
            if(upcoming_events)
                args['events'] = upcoming_events;
            if(en_appt_override)
                args['en_appt_override']=1;
            if(test_mode)
                args['test_mode']=1;
            $.get('/',args,function(resp){
                if(typeof resp.ok == 'undefined')
                    return;
                if(resp.ok) {
                    if(resp.events) {
                        for(var ii in resp.events) {
                            resp.events[ii].start = moment(resp.events[ii].start);
                            resp.events[ii].end = moment(resp.events[ii].end);
                        }
                        upcomingEvents = resp.events;
                    }
                    var withSlots = resp.data.filter(function(d){return d.slots > 0});

                    if(isFuture && withSlots.length === 0)
                    {
                        appointment_calendar.find('.unopen-month').show();
                        appointment_calendar.find('button.reserve-date').hide();
                    }

                    cal.setEvents(withSlots);
                }
                if(qparams['apt'])
                    $('.calendar-day-'+qparams['apt'].format('YYYY-MM-DD')).click();
                $('.clndr-holder .loading', appointment_calendar).hide();
            });
        }

        function makeTimeButton(currentEvent, isCardButton) {
            date=moment(currentEvent.date); 
                        
            var btn=$('<button type="button">'+date.format('h:mma')+'</button>');
            btn.data('event', currentEvent);
            btn.data('is-card-button', isCardButton);
            btn.click(function(){
                var button = $(this);
                appointment_calendar.find('.top-times button').not(button).removeClass('active');//deselect mobile experience
                appointment_calendar.find('.card .times button').not(button).removeClass('active');//deselect desktop experience
                $('.card', appointment_calendar).removeClass('active-mobile');//deselect mobile experience
                $('.card', appointment_calendar).removeClass('active-desktop');//deselect desktop experience
                if(button.data('is-card-button')) {
                    button.closest('.card').find('.errors').html('');
                    if(button.hasClass('active')) {
                        button.removeClass('active');                  
                        appointment_calendar.removeClass('time-selected');
                    } else {
                        button.addClass('active');
                        button.closest('.card').addClass('active-desktop').data('selectedTime', button.data('event'));
                        appointment_calendar.addClass('time-selected');
                    }
                } else {
                    var counterparts = button.data('counterparts');
                    for(var ii in counterparts) {
                        counterparts[ii].closest('.card').find('.errors').html('');
                    }
                    if(button.hasClass('active')) {
                        button.removeClass('active');
                        appointment_calendar.removeClass('time-selected');
                    } else {
                        button.addClass('active');
                        for(var ii in counterparts) {
                            counterparts[ii].closest('.card').addClass('active-mobile').data('selectedTime', counterparts[ii].data('event'));
                        }
                        appointment_calendar.addClass('time-selected');
                    }
                }
            });
            if(qparams['apt'] && qparams['apt'].isSame(date)) 
                btn.click();
            return btn;
        }

        function makeCard(currentEvent)
        {
            var currentConfig = config[currentEvent.type];

            var hasGuests = false;
            var hasDuration = false;
            var detailsArray = currentConfig.list_details.slice(0);
            for(var ii in detailsArray) {
                if(detailsArray[ii].includes('[guests]')) {
                    if(typeof currentEvent.guests != 'undefined') {
                        detailsArray[ii] = detailsArray[ii].replace('[guests]', currentEvent.guests);
                        hasGuests = true;
                    } else {
                        detailsArray[ii] = '';
                    }
                }

                if(detailsArray[ii].includes('[duration]')) {
                    if(typeof currentEvent.duration != 'undefined') {
                        var duration = currentEvent.duration > 90 ? (currentEvent.duration/60)+'-hour' : currentEvent.duration+'-minute';
                        detailsArray[ii] = detailsArray[ii].replace('[duration]', duration);
                        hasDuration = true;
                    } else {
                        detailsArray[ii] = '';
                    }
                }
            }
            detailsArray = detailsArray.filter(function(item){return item});

            if(!hasGuests && typeof currentEvent.guests != 'undefined')
                detailsArray.unshift('Maximum of '+currentEvent.guests+' guests');

            if(!hasDuration && typeof currentEvent.duration != 'undefined') {
                var dur = currentEvent.duration;
                if(dur > 90) {
                    detailsArray.unshift('Extended '+(dur/60)+'-hour appointment');
                } else {
                    detailsArray.unshift(dur+'-minute appointment');
                }                         
            }

            var price = false;
            var fee = getFeeForEvent(currentEvent);
            var day = false;
            if(typeof currentConfig.booking_fee != 'undefined' && typeof currentConfig.booking_fee['day'+moment(currentEvent.date).isoWeekday()] != 'undefined')
                day = currentConfig.booking_fee['day'+moment(currentEvent.date).isoWeekday()];
            if(fee && day && day.message)
            {
                var li = $('<li/>');
                li.append(currentConfig.booking_fee_name+': $'+fee);
                if(day.message)
                {
                    var button = $('<button/>', {
                        'type': 'button',
                        'class': 'info-button',
                        'data-title': currentConfig.booking_fee_name,
                        'data-message': day.message,
                    });
                    button.html('<span class="screen-reader-text">detail</span></button>');
                    li.append(button);
                }

                detailsArray.push(li);
            }

            var listDetails = false;
            if(detailsArray)
            {
                listDetails=$('<ul>');
                for(var j in detailsArray)
                {
                    if(typeof detailsArray[j] == 'object')
                        listDetails.append(detailsArray[j]);
                    else
                        listDetails.append('<li>'+detailsArray[j]+'</li>');
                }
                $('.info-button', listDetails).click(infoButtonClick);
            }
                    
            var card='<div class="card">';
                card+='<div class="top">';
                    card+='<div class="image-slider"></div>';
                    card+='<div class="info">';
                        card+='<h3></h3>';
                        card+='<p class="subheading"></p>';
                        card+='<p class="price"></p>';
                        card+='<div class="times"></div>';
                        card+='<button type="button" class="primary-button book">Book Appointment</button>';
                        card+='<div class="errors"></div>';
                        card+='<p class="reserve-time">You will have <strong><span class="time"></span> minutes</strong> to complete your profile and confirm your appointment once you reserve your date.</p>';
                    card+='</div>';
                card+='</div>';
                card+='<div class="bottom">';
                    card+='<h4>Appointment details</h4>';
                    card+='<ul></ul>';
                card+='</div>';
            card+='</div>';
            card=$(card);

            if(currentConfig.heading)
                $('h3', card).html(currentConfig.heading);
            else
                $('h3', card).remove();

            if(currentConfig.subheading)
                $('.subheading', card).html(currentConfig.subheading);
            else
                $('.subheading', card).remove();

            if(fee)
                $('.price', card).html('$'+fee);
            else
                $('.price', card).remove();

            if(listDetails)
                $('.bottom ul', card).replaceWith(listDetails);
            else
                $('.bottom ul', card).remove();

            if(currentConfig.detail)
                $('.bottom ul', card).before(currentConfig.detail);
            
            if(!listDetails && !currentConfig.detail)
                $('.bottom', card).remove();

            if(currentEvent.reserve)
                $('.reserve-time .time', card).html(currentEvent.reserve);
            else
                $('.reserve-time', card).remove();

            if(currentConfig.images && currentConfig.images.length > 0)
                $('.image-slider', card).append(currentConfig.images);
            else
                $('.image-slider', card).remove();

            if(currentConfig.vip)
                card.addClass('vip');

            card.data('setTimes', function(times){
                if(times && times.length > 0) {
                    $('.times', card).append(times);
                } else {
                    card.addClass('inactive');
                    $('.times, .price, button.book', card).remove();
                    if(currentConfig.heading) {
                        var title = currentConfig.heading;
                        title = title.replace('appointments', '');
                        title = title.replace('appointment', '');
                        title += ' appointments';
                        $('.subheading', card).html('No '+title+' are available on this day.');
                    } else {
                        $('.subheading', card).html('Not available on this day.');
                    }                    
                }
            });

            $('button.book', card).click(function(){
                if($(this).css('opacity') != '1') {
                    $('.errors', card).html('Please select a time to continue');
                    return;
                }

                selectedTimeSlot = card.data('selectedTime');
                selectedCard = card;
                $(this).attr('disabled',true);
                grecaptcha.execute(recaptcha_id);
            });

            $('.image-slider', card).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                //arrows: false,
                fade: true,
                prevArrow:'<div class="prev"><i class="fa fa-angle-left"></i></div>',
                nextArrow:'<div class="next"><i class="fa fa-angle-right"></i></div>',
            });

            return card;
        }

        function getFeeForEvent(currentEvent)
        {
            var date = moment(currentEvent.date);
            var currentConfig = config[currentEvent.type];
            if(typeof currentConfig != 'undefined' && typeof currentConfig.booking_fee != 'undefined' && typeof currentConfig.booking_fee['day'+date.isoWeekday()] != 'undefined')
            {
                var day = currentConfig.booking_fee['day'+date.isoWeekday()];
                var start = true;//empty is ok
                var end = true;
                if(day.start)
                {
                    start = moment(day.start+'T000000');
                    start = start.isValid() && date.isSameOrAfter(start);
                }
                if(day.end)
                {
                    end = moment(day.end+'T235959');
                    end = end.isValid() && date.isBefore(end);
                }
                if(start && end)
                {
                    return parseFloat(day.fee);
                }
            }
            return 0;
        }

        function infoButtonClick() {
            var button = $(this);
            if(!$(this).data('popup')) {
                var popup = $('<div class="info-popup">');
                var close = $('<button type="button" class="close"><span class="screen-reader-text">close</span></button>');
                var message = $(this).data('message');
                popup.html(message);
                if($(this).data('title'))
                    popup.prepend('<h3>'+$(this).data('title')+'</h3>');
                popup.append(close);
                popup.hide();
                $(this).data('popup', popup);
                var wrap = $('<div class="info-popup-wrap">');
                wrap.append(popup);
                $(this).after(wrap);
            }
            if($(this).data('popup').is(':visible')) {
                $('.info-popup').stop().fadeOut(250);
                $(document.body).off('click.info-popup');
            } else {
                $(this).data('popup').stop().fadeIn(250);
                $(document.body).on('click.info-popup', function(e){
                    if(button.is(e.target))
                        return;
                    if($(e.target).closest('.info-popup').length > 0) {
                        if(!$(e.target).closest('.info-popup').find('.close').is(e.target))
                            return;
                    }
                    $('.info-popup').stop().fadeOut(250);
                    $(document.body).off('click.info-popup');
                });
            }
            
        }
        
        if(typeof qparams['apt'] != 'undefined')
        {
            var apt=moment(qparams['apt'].replace('+',' '));
            if(apt.isValid() && apt.isAfter(moment()) && apt.isBefore(moment().add(6, 'months')))
            {
                qparams['apt']=apt;
                var mod2Start = apt.clone().subtract(apt.diff(calendar_start, 'month') % 2, 'M').startOf('month');
                cal.setIntervalStart(mod2Start);
                getCalendarEvents(mod2Start.format('YYYY-MM'), moment().diff(mod2Start, 'month') < -1);
            }
            else
            {
                qparams['apt']=false;
                getCalendarEvents(calendar_start.format('YYYY-MM'), moment().diff(calendar_start, 'month') < -1);
            }
        }
        else
        {
            qparams['apt']=false;
            getCalendarEvents(calendar_start.format('YYYY-MM'), moment().diff(calendar_start, 'month') < -1);
        }
    });
});